// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"284":"8bf92b7b","626":"e728cf4a","651":"46440fd7"}[chunkId] + ".chunk.js");